export const SLOT_MIN = 30;
export const SLOTS_PER_DAY = 48; // 24h * 2

export const TASK_COLORS = {
  indigo: { block: "bg-indigo-100 border-indigo-300 text-indigo-900", solid: "bg-indigo-500", dot: "bg-indigo-500", ring: "ring-indigo-300" },
  emerald: { block: "bg-emerald-100 border-emerald-300 text-emerald-900", solid: "bg-emerald-500", dot: "bg-emerald-500", ring: "ring-emerald-300" },
  amber: { block: "bg-amber-100 border-amber-300 text-amber-900", solid: "bg-amber-500", dot: "bg-amber-500", ring: "ring-amber-300" },
  rose: { block: "bg-rose-100 border-rose-300 text-rose-900", solid: "bg-rose-500", dot: "bg-rose-500", ring: "ring-rose-300" },
  sky: { block: "bg-sky-100 border-sky-300 text-sky-900", solid: "bg-sky-500", dot: "bg-sky-500", ring: "ring-sky-300" },
  violet: { block: "bg-violet-100 border-violet-300 text-violet-900", solid: "bg-violet-500", dot: "bg-violet-500", ring: "ring-violet-300" },
  teal: { block: "bg-teal-100 border-teal-300 text-teal-900", solid: "bg-teal-500", dot: "bg-teal-500", ring: "ring-teal-300" },
  orange: { block: "bg-orange-100 border-orange-300 text-orange-900", solid: "bg-orange-500", dot: "bg-orange-500", ring: "ring-orange-300" },
};
export const taskColor = (c) => TASK_COLORS[c] || TASK_COLORS.indigo;

export const WORK_MODES = {
  office: { label: "Office", band: "bg-indigo-500", tint: "bg-indigo-500/[0.06]", text: "text-indigo-600" },
  home: { label: "Home", band: "bg-emerald-500", tint: "bg-emerald-500/[0.06]", text: "text-emerald-600" },
  remote: { label: "Remote", band: "bg-sky-500", tint: "bg-sky-500/[0.06]", text: "text-sky-600" },
  travel: { label: "Travel", band: "bg-amber-500", tint: "bg-amber-500/[0.07]", text: "text-amber-600" },
};

// -- wall-clock helpers (no timezone conversion) --
export function parseWall(iso) {
  const p = iso.slice(0, 19).split(/[-T:]/).map(Number);
  return new Date(p[0], (p[1] || 1) - 1, p[2] || 1, p[3] || 0, p[4] || 0, p[5] || 0);
}
function pad(n) { return String(n).padStart(2, "0"); }
export function toWall(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
}
export function dateKey(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function minutesFromMidnight(date) {
  return date.getHours() * 60 + date.getMinutes();
}
export function durationMin(startIso, endIso) {
  return Math.round((parseWall(endIso) - parseWall(startIso)) / 60000);
}

export function startOfWeek(date) {
  const d = new Date(date);
  const day = (d.getDay() + 6) % 7; // Monday = 0
  d.setDate(d.getDate() - day);
  d.setHours(0, 0, 0, 0);
  return d;
}
export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}
export function weekDays(date) {
  const s = startOfWeek(date);
  return Array.from({ length: 7 }, (_, i) => addDays(s, i));
}
export function slotToDate(day, slotIndex) {
  const d = new Date(day);
  d.setHours(Math.floor(slotIndex / 2), (slotIndex % 2) * 30, 0, 0);
  return d;
}
export function fmtHour(h) {
  if (h === 0) return "12 AM";
  if (h === 12) return "12 PM";
  return h < 12 ? `${h} AM` : `${h - 12} PM`;
}
export function fmtRange(startIso, endIso) {
  const s = parseWall(startIso), e = parseWall(endIso);
  const t = (d) => d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return `${t(s)} – ${t(e)}`;
}
export function fmtMinutes(m) {
  const h = Math.floor(m / 60), mm = m % 60;
  return h && mm ? `${h}h ${mm}m` : h ? `${h}h` : `${mm}m`;
}
export const isToday = (d) => dateKey(d) === dateKey(new Date());
